export function getApplicationFormQuery(
  phone: string,
  email: string,
  realtyType: string,
  realtyCategory: string,
  dealType: string,
  label: string,
  address: string,
  roomCount?: string,
) {
  // tslint:disable-next-line:max-line-length
  return [
    `?phone=${phone}`,
    `address=${encodeURIComponent(address)}`,
    `realtyType=${realtyType}`,
    `realtyCategory=${realtyCategory}`,
    `dealType=${dealType}`,
    `email=${encodeURIComponent(email)}`,
    roomCount && `roomCount=${roomCount}`,
    `label=${label}`,
  ].filter((p) => !!p).join('&');
}
